import PlatformUserModel from "../model/PlatformUserModel";
import PlatformUserService from "./PlatformUserService";

export default class PlatformUserTrackingService {
    /**
     * @constructor
     * @param {PlatformUserService} platformUserService 
     * @param {PlatformUserModel} platformUserModel 
     */
    constructor(platformUserService, platformUserModel) {
        this._platformUserService = platformUserService;
        this._platformUserModel = platformUserModel;
    }

    async initialize() {
        const completionStatus = this._platformUserModel.completionStatus;
        if (completionStatus !== PlatformUserModel.COMPLETION_STATUS.COMPLETED) {
            console.log(`[${PlatformUserTrackingService.name}] Setting completion_status for learner to 'incomplete'.`);
            await this._platformUserService.setCompletionStatus({ completionStatus: PlatformUserModel.COMPLETION_STATUS.INCOMPLETE });
            this._platformUserModel.completionStatus = PlatformUserModel.COMPLETION_STATUS.INCOMPLETE;
        }
    }

    /**
     * @param {Object} params
     * @param {number} params.groupSpiritScore - Group spirit score.
     * @param {number} params.trustScore - Trust score.
     */
    async complete({ groupSpiritScore, trustScore }) {
        if (this._platformUserModel.completionStatus === PlatformUserModel.COMPLETION_STATUS.COMPLETED) {
            return;
        }

        console.log(`[${PlatformUserTrackingService.name}] Setting completion_status for learner to 'completed'.`);
        console.log(`[${PlatformUserTrackingService.name}] Setting group_spirit_score for learner to '${groupSpiritScore}'.`);
        console.log(`[${PlatformUserTrackingService.name}] Setting trust_score for learner to '${trustScore}'.`);

        await Promise.all([
            this._platformUserService.setCompletionStatus({ completionStatus: PlatformUserModel.COMPLETION_STATUS.COMPLETED }),
            this._platformUserService.putScore({
                groupSpirit: groupSpiritScore,
                trust: trustScore,
            }),
            this._platformUserService.patchCompleteGameSession({
                sessionId: this._platformUserModel.sessionId,
            }),
        ]);
        this._platformUserModel.completionStatus = PlatformUserModel.COMPLETION_STATUS.COMPLETED;
    }

    /**
     * @param {Object} params
     * @param {string} params.conversationId Unique conversation identifier.
     * @param {string} params.summary Summary text.
     * @param {Array<{quote: string, feedback: string}>} params.feedbackItems Feedback items from the conversation.
     */
    async reportConversationResult({ conversationId, summary, feedbackItems }) {
        await this._platformUserService.putConversationResult({
            conversationId,
            summary,
            feedbackItems,
        });
    }

    /**
     * @param {Object} params
     * @param {string} params.reflectionId Unique reflection identifier.
     * @param {string} params.summary Summary text.
     */
    async reportReflectionResult({ reflectionId, summary }) {
        await this._platformUserService.putReflectionResult({
            reflectionId,
            summary,
        });
    }
}
